import { Conditional } from 'components/pcc-components';
import { CatHeading } from 'components/blocks-components';
import { useTranslations } from 'next-intl';
import { capitalizeText } from '@cat-ecom/common/utils/commonUtils';
import { MyEquipmentHeaderProps } from '../../types';
import EquipmentChangeButton from 'components/equipment-change-button';

export const MyEquipmentHeader = ({
  showChangeButton
}: Readonly<MyEquipmentHeaderProps>) => {
  const t = useTranslations();

  return (
    <div className="d-block d-blg-none mb-2 d-flex justify-content-between align-items-center">
      <CatHeading variant="title">
        <span className="u-color--Black">{capitalizeText(t('MY_EQUIP'))}</span>
      </CatHeading>
      <Conditional test={showChangeButton}>
        <EquipmentChangeButton ga_event_context="Homepage Menu">
          {t('CHANGE')}
        </EquipmentChangeButton>
      </Conditional>
    </div>
  );
};
